import slugify from "slugify";

export const countryNameToCodeMap: Record<string, string> = {
  // North Africa
  'algeria': 'dz',
  'algérie': 'dz',
  'egypt': 'eg',
  'égypte': 'eg',
  'libya': 'ly',
  'libye': 'ly',
  'morocco': 'ma',
  'maroc': 'ma',
  'tunisia': 'tn',
  'tunisie': 'tn',
  'sudan': 'sd',
  'soudan': 'sd',
  'south sudan': 'ss',
  'soudan du sud': 'ss',

  // West Africa
  'benin': 'bj',
  'bénin': 'bj',
  'burkina faso': 'bf',
  'cape verde': 'cv',
  'cap-vert': 'cv',
  'côte d\'ivoire': 'ci',
  'ivory coast': 'ci',
  'gambia': 'gm',
  'gambie': 'gm',
  'ghana': 'gh',
  'guinea': 'gn',
  'guinée': 'gn',
  'guinea-bissau': 'gw',
  'guinée-bissau': 'gw',
  'liberia': 'lr',
  'libéria': 'lr',
  'mali': 'ml',
  'mauritania': 'mr',
  'mauritanie': 'mr',
  'niger': 'ne',
  'nigeria': 'ng',
  'senegal': 'sn',
  'sénégal': 'sn',
  'sierra leone': 'sl',
  'togo': 'tg',

  // Central Africa
  'cameroon': 'cm',
  'cameroun': 'cm',
  'central african republic': 'cf',
  'république centrafricaine': 'cf',
  'chad': 'td',
  'tchad': 'td',
  'congo republic': 'cg',
  'république du congo': 'cg',
  'democratic republic of the congo': 'cd',
  'république démocratique du congo': 'cd',
  'equatorial guinea': 'gq',
  'guinée équatoriale': 'gq',
  'gabon': 'ga',
  'são tomé and príncipe': 'st',
  'sao tomé-et-principe': 'st',

  // East Africa
  'burundi': 'bi',
  'comoros': 'km',
  'comores': 'km',
  'djibouti': 'dj',
  'eritrea': 'er',
  'érythrée': 'er',
  'ethiopia': 'et',
  'éthiopie': 'et',
  'kenya': 'ke',
  'madagascar': 'mg',
  'malawi': 'mw',
  'mauritius': 'mu',
  'maurice': 'mu',
  'mozambique': 'mz',
  'rwanda': 'rw',
  'seychelles': 'sc',
  'somalia': 'so',
  'somalie': 'so',
  'tanzania': 'tz',
  'tanzanie': 'tz',
  'uganda': 'ug',
  'zambia': 'zm',
  'zambie': 'zm',
  'zimbabwe': 'zw',

  // Southern Africa
  'angola': 'ao',
  'botswana': 'bw',
  'eswatini': 'sz',
  'swaziland': 'sz',
  'lesotho': 'ls',
  'namibia': 'na',
  'namibie': 'na',
  'south africa': 'za',
  'afrique du sud': 'za',

  // Indian Ocean Islands
  'mayotte': 'yt',
  'réunion': 're'
};

export const getCountryCode = (countryName: string): string => {
  const normalized = countryName.toLowerCase().trim();
  return countryNameToCodeMap[normalized] || slugify(countryName);
};